export const planList = () => {
    return { 1: 'Annual', 2: 'Monthly', 3: 'Free' };
}